export default __webpack_public_path__ + "static/media/Badge-Icon.1d3538b7.svg";